var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ClicColInterno',{key:_vm.componentKey,attrs:{"alignSelf":"end","cp":_vm.cp}},[_c('ClicSwaggerInterno',{ref:"swaggerInterno",attrs:{"cp":_vm.cp,"state":_vm.state,"url":_vm.url,"spec":_vm.spec}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }